import './styles.css';

export const Footer: React.FC = () => {
	return (
		<div className="copyright">Crafted with ❤️ (and a fair bit of caffeine)<br />by <a href="https://t.me/NightNei" target="_blank" rel="noreferrer">NightNei</a></div>
	);
};